/*
 * @Description: 地域绑定
 * @Author: pu.yuchun
 * @LastEditors  : pu.yuchun
 * @Date: 2019-09-12 13:51:00
 * @LastEditTime : 2020-01-03 16:18:08
 */
'use strict';
angular.module('bindRegionModule', ['tManageMentServiceModule']).controller('bindRegionCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    'trsHttpService',
    'modalDialog',
    '$validation',
    'dateFilter',
    '$element',
    'moduleId',
    'loginService',
    'globleParamsSet',
    function($scope, $q, $modalInstance, trsHttpService, modalDialog, $validation, dateFilter, $element, moduleId, loginService, globleParamsSet) {
        initStatus();
        initData();
        /**
         * @description: 初始化装填
         * @param {type}
         * @return:
         */
        function initStatus() {
            $scope.token = '';
            $scope.data = {
                userCurr: {}
            };
            $scope.selectNode = {}; // 被选中节点
            $scope.treeData = [];
            $scope.regionData = [];
            $scope.selectedRegion = []; // 被选择的地域
            // tree 组件配置
            $scope.treeOptions = {
                nodeChildren: 'childlist',
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: 'a1 manage-tree',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'icon-previewright a3',
                    iCollapsed: 'icon-previewright a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'rolegrouplabselected'
                },
                isLeaf: function(node) {
                    return node.noChildren;
                }
            };
        }
        /**
         * @description:初始化数据
         * @param {type}
         * @return:
         */
        function initData() {
            if ($scope.data.userCurr.TENANTID) {
                globleParamsSet.getTokenService(user.TENANTID).then(function(data) {
                    $scope.token = data.token;
                    requestData();
                });
            } else {
                loginService.getCurrLoginUser().then(function(userData) {
                    $scope.data.userCurr = userData;
                    globleParamsSet.getTokenService(userData.TENANTID).then(function(data) {
                        $scope.token = data.token;
                        requestData();
                    });
                });
            }
        }
        /**
         * @description: 数据请求
         * @param {type}
         * @return:
         */
        function requestData() {
            getTreeData();
        }
        /**
         * @description: 获取节点树
         * @param {node} 父节点默认不传递
         * @return:
         */
        function getTreeData(node) {
            var areaNum = node ? node.areanum : '';
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/region/getRegionTree',
                    {
                        tenantId: $scope.data.userCurr.TENANTID,
                        areaNum: areaNum
                    },
                    'get',
                    '',

                    { token: $scope.token }
                )
                .then(function(data) {
                    $scope.regionData = data.datas;
                    getSelectTreeData(data.datas);
                });
        }
        /**
         * @description: 获取节点树，处理被选中节点
         * @param {type}
         * @return:
         */
        function getSelectTreeData(treeData) {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/moduleConfig/findModuleRegion',
                    {
                        tenantId: $scope.data.userCurr.TENANTID,
                        moduleId: moduleId
                    },
                    'get',
                    '',
                    { token: $scope.token }
                )
                .then(function(data) {
                    $scope.selectedRegion = data.datas;
                    handSelectData($scope.regionData);
                });
        }
        /**
         * @description: 选择节点
         * @param {type}
         * @return:
         */
        $scope.showToggle = function(node) {
            if (node.noChildren || node.childlist.length) return;
            // 请求下拉
            var params = {
                areaNum: node.areanum,
                tenantId: $scope.data.userCurr.TENANTID
            };
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/region/getRegionTree', params, 'get', '', { token: $scope.token }).then(data => {
                if (data.datas && data.datas.length) {
                    node.childlist = data.datas;
                    handSelectData(data.datas);
                } else {
                    node.noChildren = true;
                }
            });
        };
        /**
         * @description: 处理被选中的数据
         * @param {type}
         * @return:
         */
        function handSelectData(treeData) {
            traverse(treeData, function(region) {
                delete region.moduleregionrelid;
            });
            if ($scope.selectedRegion.length) {
                $scope.selectedRegion.forEach(function(item) {
                    traverse(treeData, function(region) {
                        if (region.dictname === item.dictname) {
                            region.moduleregionrelid = item.moduleregionrelid;
                        }
                    });
                });
            }
        }

        /**
         * @description: 绑定操作
         * @param {type}
         * @return:
         */
        $scope.toggleBind = function(item, e) {
            e.stopPropagation();
            if (item.moduleregionrelid) {
                unBindRegion(item);
            } else {
                bindRegion(item);
            }
        };
        /**
         * @description:绑定地域
         * @param {type}
         * @return:
         */
        $scope.bindRegion = function(item, e) {
            e.stopPropagation();
            if (item.moduleregionrelid) return;
            var params = {
                moduleId: moduleId,
                moduleRegionRelId: item.moduleregionrelid,
                regionId: item.regionid,
                tenantId: $scope.data.userCurr.TENANTID,
                dictName: item.dictname,
                areaNum: item.areanum,
                dictNum: item.dictnum,
                content: item.content
            };
            // 地域绑定请求数据
            trsHttpService.httpServer('/api/tenantcenter/moduleConfig/bindModuleRegion', params, 'post', '', { token: $scope.token }).then(function(data) {
                if (data.code == '200') {
                    getSelectTreeData();
                }
            });
        };
        /**
         * @description: 解除绑定
         * @param {type}
         * @return:
         */
        $scope.unBindRegion = function(item, e) {
            e.stopPropagation();
            if (!item.moduleregionrelid) return;
            var params = {
                moduleRegionRelId: item.moduleregionrelid
            };
            trsHttpService.httpServer('/api/tenantcenter/moduleConfig/unBindModuleRegion', params, 'post', '', { token: $scope.token }).then(function(data) {
                if (data.code == '200') {
                    getSelectTreeData();
                }
            });
        };

        // 选择节点
        $scope.checkNode = function(node) {
            // var obj = getNode(path);
            // obj.checked = true;
            $scope.selectNode = node;
        };

        /** [cancel description]点击取消的操作 */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /** [confirm description] 点击确定保存修改的时候对服务项的数据进行处理*/
        $scope.confirm = function() {
            // if (!$scope.treeData.length) return;
            // var ids = [];
            // traverse($scope.treeData, function(item) {
            //     if (item.checked) ids = ids.concat(item.ids);
            // });
            $modalInstance.close();
        };
        // 递归遍历
        function traverse(arr, fn) {
            arr.forEach(function(item) {
                fn(item);
                item.childlist && traverse(item.childlist, fn);
            });
        }
    }
]);
